// extracted by mini-css-extract-plugin
export default {"root":"eFcxqdHJ_L","title":"tWIyYwoC9Q","list":"g1_Lm8WmJ5","item":"zN2YzPGVZU"};